export const PERSONAL_PICKUPS = {
    QR_CODE_TYPES: {
        KZ: 'KZ',
        KP: 'KP'
    },
    DELIVERY_METHODS: {
        TRANSPORT: 'TRANS'
    },
    STATUS: {
        UNCONFIRMED: 10,
        CONFIRMED: 20
    }
} as const

export const PERSONAL_PICKUPS_STATUS_UNCONFIRMED = PERSONAL_PICKUPS.STATUS.UNCONFIRMED
export const PERSONAL_PICKUPS_STATUS_CONFIRMED = PERSONAL_PICKUPS.STATUS.CONFIRMED
